import { create } from "zustand";

interface GuidedProjectStore {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useGuidedProjectStore = create<GuidedProjectStore>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));
